<template>
    <div class="container">
        <footer class="d-flex flex-column justify-content-center position-relative my-2" style="z-index: 3;">
            <div class="d-flex flex-column flex-lg-row align-items-center justify-content-between">
                <!-- Copyright -->
                <div class="d-flex align-items-center">
                    <i>Designed & built by Arya Bun <i class='bx bx-copyright'></i> 2026</i>
                </div>
                <!-- GitHub -->
                <div class="d-flex my-2">
                    <a class="btn btn-light rounded-pill d-flex align-items-center justify-content-center"
                        href="https://github.com/aryabun/my-portfolio" target="_blank">
                        <i class='bx bxl-github pe-2' style="font-size: 25px;"></i>
                        Source
                    </a>
                </div>
            </div>
        </footer>
    </div>
</template>